import React, { Component } from 'react';
import { TextInput, Select, Image } from 'library';

class Modal extends Component {
    static component_name = 'EmptyModal';

    constructor(props) {
        super(props);
        this.config = {
            form_components: [
                <TextInput label="class" name="className" default="" />,
                <Select label="show" name="show" boolean />,
            ],
            can_have_children: true,
        };

        this.on_hide = this.on_hide.bind(this);
    }

    on_hide() {
        if (this.props.on_hide) {
            this.props.on_hide();
        }
    }

    render() {
        const backgroundStyle = {
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: '0px',
            left: '0px',
            background: 'rgba(255,255,255,0.2)',
            zIndex: '1',
            margin: 'auto',
            backdropFilter: 'blur(1px)'
        };

        const height = window.outerHeight * 0.7;

        const modalStyle = {
            border: 'none',
        };
        let modalClass = 'modal fade';
        if (this.props.show === true) {
            modalClass += ' show';
            modalStyle.display = 'block';
        }

        const floating_close_style = {
            position: 'absolute',
            top: '6px',
            right: '6px',
            margin: '0px',
            minWidth: '0px',
            borderRadius: '4px',
            color: 'white',
            background: '#FC7F53',
            padding: '10px',
            lineHeight: '15px',
        };
        let floating_close = (
            <div onClick={this.on_hide} style={floating_close_style}>
                <Image
                    src="/static/images/reporting/Vector.svg"
                    className="icon"
                    css={{ width: '15px' }}
                />
            </div>
        );

        return (
            <div
                className={modalClass}
                tabIndex="-1"
                role="dialog"
                style={modalStyle}
            >
                <div onClick={this.on_hide} style={backgroundStyle} />
                <div
                    className="modal-dialog"
                    role="document"
                    style={{
                        zIndex: '10',
                        maxWidth: '2000px',
                        marginTop: `${height * 0.2}px`,
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <div
                        className="modal-content"
                        style={{
                            width: '1000px',
                            maxHeight: height,
                            overflow: 'auto',
                            boxShadow: '2px 2px 10px rgba(255,255,255,.2)',
                        }}
                    >
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default Modal;
